/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const redSmsCallbackSchema = z
	.object({
		uuid: z.string(),
		parent_uuid: z.string().nullish(),
		status: z.string(),
		status_time: z.int(),
		price: z.number().optional(),
		type: z.string().optional(),
	})
	.describe("Сериализатор обработки коллбэка от RedSMS.");
